import { ListPaginationMeta } from "utils/helpers/pagination";

export type adminManagementStatus = "active" | "not_active";

export type statusFilter = "ALL" | adminManagementStatus;

export interface adminManagementTableRow {
    userID?:        string,
    initials?:      string,
    fullName:       string,
    role:           string,
    phoneNo:        string,
    email:          string,
    department:     string,
    status:         adminManagementStatus,
    departureDate?: string,
    profilePic?:    string,
    createdAt?:     string,
    lastLogin?:     string,
}

export interface newUserForm {
    fullName:     string,
    email:        string,
    role:         string,
    mobileNumber: string,
    department:   string,
}

export interface userDetailes {
    id:           string,
    fullName:     string,
    email:        string,
    role:         string,
    mobileNumber: string,
    department:   string,
    status:       adminManagementStatus,
    profilePic:   string,
    createdAt:    string,
    lastLogin:    string,
}

export type AdminManagementListMeta = ListPaginationMeta;

export interface AdminManagementListResponse {
    statusCode: number,
    message:    string | Record<string, string>,
    data:       adminManagementTableRow[],
    meta?:      AdminManagementListMeta,
}

export interface adminManagementState {
    statusFilter:   statusFilter,
    data:           adminManagementTableRow[],
    page:           number,
    perPage:        number,
    meta:           AdminManagementListMeta,
    isLoading:      boolean,
    error:          string | null,
    newUserForm:    newUserForm,
    isAddModalOpen: boolean,
    userDetailes:   userDetailes | null,
}

export const STATUS_OPTIONS: statusFilter[] = [
  "ALL",
  "active",
  "not_active",
];

export interface DepartmentOption {
    value:    string,
    labelKey: string,
}

export const DEPARTMENT_OPTIONS: DepartmentOption[] = [
  { value: "PRODUCTION_AND_CHASSIS", labelKey: "ADMIN_MANAGEMENT.FORM.DEPARTMENT_OPTIONS.PRODUCTION_AND_CHASSIS" },
  { value: "HYDRAULICS_AND_MECHANICS", labelKey: "ADMIN_MANAGEMENT.FORM.DEPARTMENT_OPTIONS.HYDRAULICS_AND_MECHANICS" },
  { value: "ENGINEERING_AND_LICENSING", labelKey: "ADMIN_MANAGEMENT.FORM.DEPARTMENT_OPTIONS.ENGINEERING_AND_LICENSING" },
  { value: "WAREHOUSE_AND_PROCUREMENT", labelKey: "ADMIN_MANAGEMENT.FORM.DEPARTMENT_OPTIONS.WAREHOUSE_AND_PROCUREMENT" },
  { value: "FINANCE_AND_ACCOUNTING", labelKey: "ADMIN_MANAGEMENT.FORM.DEPARTMENT_OPTIONS.FINANCE_AND_ACCOUNTING" },
  { value: "SALES_AND_CUSTOMER_SERVICE", labelKey: "ADMIN_MANAGEMENT.FORM.DEPARTMENT_OPTIONS.SALES_AND_CUSTOMER_SERVICE" },
];